export default `return mat2( cos( r ), sin( r ), -sin( r ), cos( r ) );
}
float de ( vec3 p ) {
  vec3 q=p;
  float d, t = 0.0; 
  q.xy=fract(q.xy)-.5;
  for( int j=0; j++<9; q+=q )
    q.xy=abs(q.xy*rotate2D(q.z + t))-.15;
    d=(length(q.xy)-.2)/1e3;
  return d;
}`